import {Component, inject, input} from '@angular/core';
import {
  InternalNotificationsStore,
  InternalNotificationType
} from 'src/app/infrastructure/internal-notifications/internal-notifications.store';

@Component({
  selector: 'app-info-button',
  templateUrl: './info-button.component.html',
  styleUrl: './info-button.component.css'
})
export class InfoButtonComponent {

  message = input.required<string>();

  private internalNotificationsStore = inject(InternalNotificationsStore);

  showMessage() {
    this.internalNotificationsStore.addNotification(this.message(), InternalNotificationType.INFO, true, "info-button");
  }
}
